(function () {
  'use strict';

  var ADD_EVENT = 'monin_add_to_cart';
  var REMOVE_EVENT = 'monin_remove_from_cart';
  var PROPERTY_KEY = '_bottles_per_unit';
  var PROPERTY_NAME = 'properties[' + PROPERTY_KEY + ']';

  var originalFetch = window.fetch.bind(window);
  var lastCart = null;

  /* ---------- helpers ---------- */

  function getBottleMap() {
    var map = {};
    document.querySelectorAll('script[data-monin-bottle-map]').forEach(function (el) {
      try {
        Object.assign(map, JSON.parse(el.textContent));
      } catch (e) {
        console.warn('[monin] Could not parse bottle map', e);
      }
    });
    return map;
  }

  function setHiddenProperty(form, value) {
    var input = form.querySelector('input[name="' + PROPERTY_NAME + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = PROPERTY_NAME;
      form.appendChild(input);
    }
    input.value = String(value);
  }

  function publish(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, payload);
      }
    } catch (e) {
      console.warn('[monin] Shopify.analytics.publish failed', e);
    }
  }

  function refreshCartSnapshot() {
    return originalFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { lastCart = cart; })
      .catch(function () {});
  }

  /* ---------- cart diff: quantity changes and removals ---------- */

  function diffCarts(prevCart, nextCart) {
    if (!prevCart || !nextCart || !Array.isArray(nextCart.items)) return;

    var nextByKey = {};
    nextCart.items.forEach(function (item) { nextByKey[item.key] = item; });

    prevCart.items.forEach(function (prevItem) {
      var nextItem = nextByKey[prevItem.key];
      var nextQty = nextItem ? nextItem.quantity : 0;
      var delta = nextQty - prevItem.quantity;
      if (delta === 0) return;

      var props = prevItem.properties || {};
      if (!(PROPERTY_KEY in props)) return; // line added before tracking existed

      var bottlesPerUnit = Number(props[PROPERTY_KEY]) || 0;
      var units = Math.abs(delta);

      publish(delta > 0 ? ADD_EVENT : REMOVE_EVENT, {
        variant_id: String(prevItem.variant_id),
        quantity: units,
        bottles_per_unit: bottlesPerUnit,
        bottle_count: bottlesPerUnit * units
      });
    });
  }

  /* ---------- watch cart AJAX calls ---------- */

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = originalFetch(input, init);

    if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
      request.then(function (res) {
        res.clone().json().then(function (nextCart) {
          diffCarts(lastCart, nextCart);
          lastCart = nextCart;
        }).catch(function () { refreshCartSnapshot(); });
      }).catch(function () {});
    } else if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      // Add responses don't return the full cart, so re-sync the snapshot
      request.then(function () { refreshCartSnapshot(); }).catch(function () {});
    }

    return request;
  };

  /* ---------- product form adds ---------- */

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;

    var map = getBottleMap();
    var formData = new FormData(form);
    var variantId = String(formData.get('id') || '');
    if (!variantId || !(variantId in map)) return;

    var quantity = parseInt(formData.get('quantity'), 10) || 1;
    var bottlesPerUnit = Number(map[variantId]) || 0;

    setHiddenProperty(form, bottlesPerUnit);

    publish(ADD_EVENT, {
      variant_id: variantId,
      quantity: quantity,
      bottles_per_unit: bottlesPerUnit,
      bottle_count: bottlesPerUnit * quantity
    });
  }, true);

  refreshCartSnapshot();
})();